<template lang="pug">
  .contract-conditions
    section.mb-4(aria-labelledby="contract-conditions-title")
      h5#contract-conditions-title.contract-section-title 重要な契約条件
      b-form-textarea.contract-conditions-textarea.white-space(:value="contract_conditions_text", :readonly="true", rows="8")
      .contract-conditions-links.mt-2
        p(v-if="showNeo", :class="showChat ? 'mb-1' : 'mb-0'")
          span.font-weight-bold desknet's NEO：
          a(href="https://www.desknets.com/neo/features/cloud/requirement.html", target="_blank", rel="noopener noreferrer") 動作環境
          span.mx-2 |
          a(href="https://www.desknets.com/neo/usersupport/cancellation/", target="_blank", rel="noopener noreferrer") 解約手続き
        p.mb-0(v-if="showChat")
          span.font-weight-bold ChatLuck：
          a(href="https://www.chatluck.com/operating/", target="_blank", rel="noopener noreferrer") 動作環境
          span.mx-2 |
          a(href="https://www.chatluck.com/support/cloud/#ac02", target="_blank", rel="noopener noreferrer") 解約手続き
    section.applicable-terms(aria-labelledby="applicable-terms-title")
      h4#applicable-terms-title.applicable-terms-title 適用される利用約款・SLA
      p 本サービスに不具合が生じた場合の対応、補償および損害賠償の責任範囲は、適用される利用約款、個別規約およびSLAに定める内容に従います。
      h5.terms-category 利用約款
      ul.mb-0.pl-3
        li(v-if="showNeo")
          a(href="https://www.desknets.com/cloud/article.pdf", target="_blank", rel="noopener noreferrer") desknet's クラウドサービス利用約款
        li(v-if="showChat")
          a(href="https://www.chatluck.com/terms/tos-cloud.pdf", target="_blank", rel="noopener noreferrer") ChatLuck クラウドサービス利用約款
      template(v-if="showIndividualTerms && (showClouza || showArena || showCyber || showMailgates)")
        h5.terms-category 個別サービス利用約款
        ul.mb-0.pl-3
          li(v-if="showClouza")
            a(href="https://www.desknets.com/neo/pdf/article_timecardp.pdf", target="_blank", rel="noopener noreferrer") タイムカード＋CLOUZA オプション利用約款
          li(v-if="showArena")
            a(href="https://www.desknets.com/cloud/article_cloudmail.pdf", target="_blank", rel="noopener noreferrer") desknet's クラウドメールサービス（WebARENA）利用約款
          li(v-if="showCyber")
            a(href="https://www.cybersolutions.co.jp/admission/admission-CYBERMAILSIGMA.pdf", target="_blank", rel="noopener noreferrer") CYBERMAILΣ利用約款
          li(v-if="showMailgates")
            a(href="https://www.cybersolutions.co.jp/admission/admission-MAILGATESSIGMA.pdf", target="_blank", rel="noopener noreferrer") MAILGATES Σ利用約款
      h5.terms-category サービス品質保証（SLA）
      ul.mb-0.pl-3
        li(v-if="showNeo")
          a(href="https://www.desknets.com/cloud/sla.pdf", target="_blank", rel="noopener noreferrer") desknet's クラウド サービス品質保証（SLA）
        li(v-if="showChat")
          a(href="https://www.chatluck.com/terms/sla-cloud.pdf", target="_blank", rel="noopener noreferrer") ChatLuck クラウド サービス品質保証（SLA）
      h5.terms-category サポートサイト
      ul.mb-0.pl-3
        li
          a(href="https://csite.desknets.com/tos.pdf", target="_blank", rel="noopener noreferrer") クラウド版サポートサイト利用約款
</template>

<script>
export default {
  name: "ContractConditions",
  props: {
    showNeo: { type: Boolean, default: false },
    showChat: { type: Boolean, default: false },
    showClouza: { type: Boolean, default: false },
    showArena: { type: Boolean, default: false },
    showCyber: { type: Boolean, default: false },
    showMailgates: { type: Boolean, default: false },
    showIndividualTerms: { type: Boolean, default: true },
  },
  data() {
    return {
      contract_conditions_text: `● 契約単位期間・最低利用期間
契約単位期間は1ヶ月および12ヶ月となります。
最低利用期間（最低契約期間）は1ヶ月間です。
各個別サービスのサービス利用期間が契約単位期間満了となった場合、当該個別サービスの利用契約は、契約単位期間満了日の翌日を起算日として自動的に更新されます。

● 支払時期・支払方法
月払いの場合、月末締め翌月末払いとなります。
年間一括払いの場合、初回請求時に一括でお支払いいただきます。
具体的な支払期限は、当社または代理店が発行する請求書に記載された期日によります。
新規契約の場合、月払い・年間一括払いのいずれの場合も、契約開始月の10日にdesknet's電子請求システム上に請求書をアップロードします。
10日が休業日の場合は、直前の営業日に発行します。
請求書の発行時には、メールにより通知します。
月払いの場合、当月利用分の請求書は同月10日にdesknet's電子請求システム上にアップロードします。
年間一括払いの場合、当年利用分の請求書は契約開始月10日にdesknet's電子請求システム上にアップロードします。
月払いの場合、追加サービス利用開始日の翌月10日に発行される請求書から反映されます。
ただし、1日にサービスを追加した場合は、当月10日に発行される請求書から反映されます。
年間一括払いの場合、追加サービス利用開始日に、追加分の請求書を発行します。

● 提供時期・課金開始
当社が利用申込を承諾した後、本サービスの利用に必要なサービス開始日、各種ID、パスワード等を文書または電子メールにより通知します。
お客様は、当社が通知するサービス開始日以降、本サービスをご利用いただけます。
サービス開始日以降、実際の利用有無にかかわらず料金支払義務が発生します。
サービス利用期間および最低利用期間の起算日は、当社が通知するサービス開始日の翌月1日とします。
ただし、サービス提供開始日が月の初日である場合は、当月1日を料金起算日とします。
毎月1日から翌月の料金起算日前日までの1か月間を料金起算対象期間とします。

● 解約・キャンセル・返金
申込後のお客様都合によるキャンセルはできません。
本サービスの利用を終了する場合、お客様は、サービス利用終了日の1か月前までに、当社が別途定める方法により当社に通知するものとします。
通知の当社到達日からサービス利用終了日までの期間が1か月に満たない場合、当該通知の当社到達日の翌月末日をサービス利用終了日とします。
本サービスの利用を終了した場合、その理由のいかんを問わず、お客様から受領したサービス料金の返金は行いません。
最低利用期間の満了日前に本サービスの利用を終了する場合、お客様は、サービス利用終了日の翌日から最低利用期間満了日までの本サービス料金を一括で支払うものとします。
解約手続その他の条件は、利用約款、個別規約、申込画面または当社Webサイト上の各サービスの解約手続きに関する案内に表示する内容に従います。

● 動作環境
本サービスの利用に必要または適したインターネット接続環境、ハードウェア、ソフトウェア等は、当社Webサイト上の各サービスの動作環境をご確認ください。`,
    };
  },
};
</script>

<style scoped>
.contract-conditions {
  border-top: 1px solid #c6c9cc;
  padding-top: 24px;
}
.white-space {
  white-space: pre-line;
}
.contract-conditions-textarea {
  line-height: 1.7;
  opacity: 1;
  resize: vertical;
}
.applicable-terms {
  background-color: #f5f5f5;
  border: 1px solid #c6c9cc;
  padding: 20px;
}
.applicable-terms p,
.applicable-terms li {
  line-height: 1.7;
}
.applicable-terms-title {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1rem;
}
.contract-section-title {
  background-color: #f5f5f5;
  border-bottom: 1px solid #dee2e6;
  border-top: 1px solid #dee2e6;
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.terms-category {
  font-weight: bold;
  font-size: 1rem;
  margin: 20px 0 8px;
}
</style>
